import React, { createRef, useEffect, useRef, useState } from "react";
import CustomSearchBar from "../../../../components/CustomSearchBar/CustomSearchBar";
import { Form, Formik } from "formik";
import close from "../../../../images/icons/close.png";
import add from "../../../../images/icons/add.png";
import * as Yup from "yup";
import FileUpload from "../../../../components/FileUpload/FileUpload";
import CustomInput from "../../../../components/CustomInput/CustomInput";
import edit from "../../../../images/icons/edit.png";
import delete_icon from "../../../../images/icons/delete.png";
import Table from "../../../../components/Table/Table";
import { Box } from "@material-ui/core";
import apiUtil from "../../../../api/apiUtil";
import CustomButton from "../../../../components/CustomButton/custombutton";
import "./MenuCategory.css";
import api from "../../../../api/api";
import menu_image from "../../../../images/icons/menu.png";
import getToken from "../../../getToken";

const MenuCategory = () => {
  const [showAddMenuCategories, setShowAddMenuCategories] = useState(false);
  const [showEditMenuCategories, setShowEditMenuCategories] = useState(false);
  const refCategoryForm = useRef();
  const refPreviewCategoryFiles = useRef(false);
  const menuCategoriesId = useRef(0);
  const [keyword, setKeyword] = useState("");

  const clickAddMenuCategories = (e) => {
    e.stopPropagation();
    if (showEditMenuCategories) {
      setShowEditMenuCategories(false);
      setTimeout(() => setShowAddMenuCategories(true), 200);
    } else {
      setShowAddMenuCategories(true);
    }
    setMenuCategoryDetail({});
  };

  let orgLevel = localStorage.getItem("orgLevel");

  const orgLevelMapCategory = {
    1: "Room",
    2: "Service",
    3: "Menu Categories",
  };
  const categoryName = orgLevelMapCategory[orgLevel] || "";

  const orgLevelMapSubCategory = {
    1: "Room Type",
    2: "Service Type",
    3: "Sub Category",
  };
  const subCategoryName = orgLevelMapSubCategory[orgLevel] || "";

  const addButtonLabels = {
    1: "Add Room",
    2: "Add Service",
    3: "Add Category",
  };
  const addButtonLabel = addButtonLabels[orgLevel] || "";

  const clickBtnClose = () => {
    setShowAddMenuCategories(false);
    setShowEditMenuCategories(false);
  };

  const clickDeleteMenuCategory = (rowData) => {
    console.log(rowData);
    if (window.confirm("Are you sure you want to delete this item?")) {
      api
        .post(`Admin/DeleteCategory?CategoryId=${rowData.id}`, {}, getToken())
        .then((result) => {
          apiUtil.parseResult(
            result,
            (response) => {
              if (response.data.statusCode === 401) {
                alert(response.data.message);
                localStorage.removeItem("user");
                window.location.href = "/login";
              } else if (response.data.value.code == 404) {
                alert(
                  `Cannot delete ${categoryName} with existing ${subCategoryName}.`
                );
              } else if (response.data.statusCode === 200) {
                alert(`${categoryName} successfully deleted.`);
                retrieveMenuCategoryList();
                console.log(response.data);
              } else {
                alert(response.data.message);
              }
            },
            (error, type) => {
              alert(error);
            }
          );
        });
    }
  };

  let AddMenuCategoriesValidation = Yup.object().shape({
    name: Yup.string().required("Please enter the name."),
    image: Yup.mixed().required("Please choose the image"),
    description: Yup.string().required("Please enter the description."),
  });

  // menu category table
  const [menuCategoryData, setMenuCategoryData] = useState({
    isLoading: false,
    grouping: false,
    limit: apiUtil.getDefaultPageSize(),
    data: [],
    total: 0,
    page: 1,
  });
  let brandId = localStorage.getItem("brandId");

  const [paramCategory, setParamCategory] = useState({
    keyword: "",
    rowLimit: 10,
    currentPage: 1,
    brandId: brandId,
  });

  const refMenuCategoriesTable = createRef();
  const retrieveMenuCategoryList = (value = paramCategory) => {
    value.keyword = keyword || "";
    setMenuCategoryData({
      ...menuCategoryData,
      isLoading: true,
    });

    api
      .post("Admin/GetCategoryListByAdmin", value, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            console.log(response);
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              setMenuCategoryData({
                isLoading: false,
                limit: response.data.data.rowLimit,
                data:
                  response.data.data.data && response.data.data.data.length > 0
                    ? response.data.data.data
                    : [],
                total: response.data.data.totalRecords,
                page: response.data.data.paging,
              });
            } else {
              setMenuCategoryData({
                isLoading: false,
                grouping: false,
                limit: 0,
                data: [],
                total: 0,
                page: 0,
              });
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });
  };

  const handleMenuCategoriesSubmit = (values, actions) => {
    const menuCategory = {
      brandId: brandId,
      ...values,
      image: values.image.replace(/^data:(.*,)?/, ""),
    };

    api
      .post("Admin/CreateCategory", menuCategory, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.value.code === 200) {
              alert(`New ${categoryName} is saved successfully.`);
              // reset the input
              actions.resetForm();
              refCategoryForm.current[1].value = "";
              refCategoryForm.current[2].value = "";
              values = {};
              setShowAddMenuCategories(false);
              // clear preview images
              refPreviewCategoryFiles.current = false;

              // refresh the table
              retrieveMenuCategoryList(paramCategory);
            } else {
              alert(response.data.statusText);
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });

    actions.setSubmitting(false);
  };

  const [menuCategoryDetail, setMenuCategoryDetail] = useState({
    name: "",
    description: "",
    image: null,
  });

  const clickBtnEditMenuCategory = (e, id) => {
    e.stopPropagation();
    clickBtnClose();
    getMenuCategoryDetail(id);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  };

  const getMenuCategoryDetail = (id) => {
    api
      .get("Admin/GetCategoryById", { categoryId: id }, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.value.code === 200) {
              setMenuCategoryDetail({
                name: response.data.value.data.name
                  ? response.data.value.data.name
                  : "",
                description: response.data.value.data.description
                  ? response.data.value.data.description
                  : "",
                image:
                  response.data.value.data.image != null
                    ? response.data.value.data.image
                    : null,
              });

              refPreviewCategoryFiles.current = true;
              setShowEditMenuCategories(true);
              menuCategoriesId.current = id;
            } else {
              alert(response.data.statusText);
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });
  };

  const editMenuCategoriesSubmit = async (values, actions) => {
    const menuCategory = {
      brandId: brandId,
      id: menuCategoriesId.current,
      ...values,
      image: values.image.replace(/^data:(.*,)?/, ""),
    };
    api
      .post("Admin/UpdateCategory", menuCategory, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.value.code === 200) {
              alert(`${categoryName} is updated successfully.`);

              // reset the input
              actions.resetForm();
              values = {};
              setShowEditMenuCategories(false);
              retrieveMenuCategoryList(paramCategory);
            } else {
              alert(response.data.statusText);
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });

    actions.setSubmitting(false);
  };

  useEffect(() => {
    retrieveMenuCategoryList();
  }, [paramCategory]);

  return (
    <>
      {showAddMenuCategories || showEditMenuCategories ? (
        <>
          <div className=" Actions space_between">
            <h6 className="title_text mt-2">{categoryName}</h6>
            <button className="btn btnClose" onClick={clickBtnClose}>
              <img src={close} className="imgClose" alt="imgClose" />
            </button>
          </div>

          <Formik
            initialValues={{
              name: menuCategoryDetail.name ? menuCategoryDetail.name : "",
              image: menuCategoryDetail.image ? menuCategoryDetail.image : "",
              description: menuCategoryDetail.description
                ? menuCategoryDetail.description
                : "",
            }}
            validationSchema={AddMenuCategoriesValidation}
            validateOnBlur={false}
            enableReinitialize={true}
            onSubmit={(values, actions) => {
              if (showEditMenuCategories) {
                editMenuCategoriesSubmit(values, actions);
              } else {
                handleMenuCategoriesSubmit(values, actions);
              }
            }}
          >
            {({ errors, touched, values, setFieldValue }) => (
              <Form
                ref={refCategoryForm}
                className="row form-container product-form"
              >
                <div className="col-6 mt-2">
                  <CustomInput
                    name="name"
                    type="text"
                    label="Name"
                    customclass="input_wrapper"
                    hideicon="true"
                  />
                </div>
                <div className="col-6 mt-2">
                  <FileUpload
                    name="image"
                    label="Image"
                    handleFile={(file) => {
                      if (file.length > 0) {
                        const reader = new FileReader();
                        refPreviewCategoryFiles.current = true;

                        reader.onload = () => {
                          if (typeof reader.result === "string") {
                            const encoded_image = reader.result;
                            setFieldValue("image", encoded_image);
                          } else {
                            console.error(
                              "Error: FileReader result is not a string."
                            );
                          }
                        };

                        reader.readAsDataURL(file[0]);
                      }
                    }}
                    refPreviewFiles={refPreviewCategoryFiles}
                  />
                </div>
                <div className="col-12 mt-2">
                  <CustomInput
                    name="description"
                    label="Description"
                    textarea="true"
                  />
                </div>
                <div className="col-12 mt-3">
                  <div className="Actions justify-content-end">
                    <button
                      type="button"
                      className="button btnCancel"
                      onClick={clickBtnClose}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="button btnSave">
                      {showAddMenuCategories ? "Create" : "Update"}
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </>
      ) : null}

      <div className=" Actions space_between">
        <h6 className="title_text mt-2">{categoryName}</h6>
        <div className="d-flex justify-content-end gap-16 align-items-center">
          {/* <CustomFilter /> */}
          <CustomSearchBar
            value={keyword}
            setValue={setKeyword}
            onSearch={() => retrieveMenuCategoryList()}
          />
          {!showAddMenuCategories && (
            <CustomButton
              icon={add}
              text={addButtonLabel}
              addIcon={true}
              className="btnAdd"
              onClick={(e) => clickAddMenuCategories(e)}
            />
          )}
        </div>
      </div>

      <div className="table_container prdouct_table menu_category_table">
        <Table
          key={menuCategoryData.total}
          ref={refMenuCategoriesTable}
          maxBodyHeight={menuCategoryData.limit * 50}
          isLoading={menuCategoryData.isLoading}
          grouping={menuCategoryData.grouping}
          limit={menuCategoryData.limit}
          data={menuCategoryData.data}
          total={menuCategoryData.total}
          page={menuCategoryData.page}
          onPageChange={(page) => {
            setParamCategory({
              ...paramCategory,
              currentPage: page,
            });

            retrieveMenuCategoryList(paramCategory);
          }}
          columns={[
            {
              title: "No",
              render: (row) => {
                const startingIndex =
                  (menuCategoryData.page - 1) * menuCategoryData.limit + 1;
                return startingIndex + row.tableData.index;
              },
              width: "80px",
              align: "center",
            },
            {
              title: "Image",
              render: (row) => {
                if (row.image == null || row.image == "") {
                  row.image = menu_image;
                }
                return (
                  <img
                    src={row.image}
                    alt=""
                    className="d-block imgProduct"
                    onError={(e) => (e.target.src = menu_image)}
                  />
                );
              },
              width: "180px",
            },
            {
              title: "Name",
              render: (row) => {
                if (row.name.length > 40) {
                  return row.name.substring(0, 39) + "...";
                }
                return row.name;
              },
              width: "220px",
            },
            {
              title: "Description",
              render: (row) => {
                if (row.description.length > 40) {
                  return row.description.substring(0, 39) + "...";
                }
                return row.description;
              },
              width: "350px",
            },
            {
              title: "Edit",
              render: (row) => {
                return (
                  <Box
                    className=" cursor-pointer"
                    onClick={(e) => clickBtnEditMenuCategory(e, row.id)}
                  >
                    <img src={edit} alt="" className="imgIcon" />
                  </Box>
                );
              },
              align: "center",
              sorting: false,
              width: "80px",
            },
            {
              title: "Delete",
              render: (row) => {
                return (
                  <Box
                    style={{ cursor: "pointer" }}
                    onClick={() => clickDeleteMenuCategory(row)}
                  >
                    <img src={delete_icon} alt="" className="imgIcon" />
                  </Box>
                );
              },
              align: "center",
              sorting: false,
              width: "80px",
            },
          ]}
        />
      </div>
    </>
  );
};

export default MenuCategory;
